export const removeMediaStreamTrack = (stream: MediaStream | null) => {
  if (!stream) return

  stream.getTracks().forEach(track => {
    track.stop()
    stream.removeTrack(track)
  })
}
